import { KNOWN_HOSTS, DEFAULT_HOST, MOBILE_HOST } from '../config.js';

// True when running inside the native Android/iOS app (Capacitor), as opposed to
// a browser. Only ever true in the APK — web builds never see window.Capacitor.
function isNativeApp() {
  return typeof window.Capacitor == 'object' &&
    typeof window.Capacitor.isNativePlatform == 'function' &&
    window.Capacitor.isNativePlatform();
}

// True when running inside the Tauri desktop shell. Tauri v2 injects
// window.__TAURI_INTERNALS__; v1 injected window.__TAURI__. In this shell the web
// client is BUNDLED LOCALLY (served from tauri://localhost), so window.location is
// meaningless for the server — same situation as the Capacitor native app.
function isTauriApp() {
  return typeof window.__TAURI_INTERNALS__ == 'object' || typeof window.__TAURI__ == 'object';
}

// The server a native shell (Tauri desktop / Capacitor mobile) must talk to. The shell
// injects window.__NEXUS_SERVER__ for multitenancy (e.g. 'company.nexuschat.uz'); without
// it, fall back to the production default.
function nativeServerHost() {
  if (typeof window.__NEXUS_SERVER__ == 'string' && window.__NEXUS_SERVER__) {
    return window.__NEXUS_SERVER__;
  }
  return MOBILE_HOST;
}

// Detect server address from the URL
export function detectServerAddress() {
  // Native app / Tauri desktop: assets are bundled (served from localhost), so
  // window.location is meaningless for the server — use the shell-configured server.
  if (isNativeApp() || isTauriApp()) {
    return nativeServerHost();
  }
  let host = DEFAULT_HOST;
  if (typeof window.location == 'object') {
    if (window.location.protocol == 'file:' || window.location.hostname == 'localhost') {
      host = KNOWN_HOSTS.local;
    } else if (window.location.hostname) {
      host = window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
  }
  return host;
}

// Detect if the page is served over HTTPS.
export function isSecureConnection() {
  // Native app / Tauri desktop always use a secure (wss://) connection to the server.
  if (isNativeApp() || isTauriApp()) {
    return true;
  }
  if (typeof window.location == 'object') {
    return window.location.protocol == 'https:';
  }
  return false;
}

export function isLocalHost() {
  if (typeof window.location == 'object') {
    return window.location.hostname == 'localhost';
  }
  return false;
}
